import type { FilterV2ActionHandler } from "@next-platform/client-common-spicy-ui";

const ignoreFilterAction: FilterV2ActionHandler = () => {};

const skipWhileLoading = ({ isLoading, actionHandler }: { isLoading: boolean; actionHandler: FilterV2ActionHandler }): FilterV2ActionHandler =>
  isLoading ? ignoreFilterAction : actionHandler;

export default skipWhileLoading;
